import CostBreakdown, { CostBreakdownProps } from './CostBreakdown';

export type { CostBreakdownProps };
export default CostBreakdown;
